import Component from "@glimmer/component";
import Box from "glesys-controlpanel/components/box";
import Table from "glesys-controlpanel/components/table";
import TableTh from "glesys-controlpanel/components/table/th";
import TableTd from "glesys-controlpanel/components/table/td";
import { t } from "ember-intl";

export default class GpuDetails extends Component {
  get gpuItems() {
    return [this.args.server.gpu];
  }

  <template>
    <Box data-test-server-gpu-details ...attributes>
      <:header>
        GPU
      </:header>
      <:default>
        <Table class="mx-[-25px]" @outsideBorders={{false}} @footer={{false}} @items={{this.gpuItems}}>
          <:header>
            <TableTh>{{t "server.details.server-gpu-type"}}</TableTh>
            <TableTh>{{t "server.details.server-gpu-number"}}</TableTh>
          </:header>
          <:body as |item|>
            <TableTd>{{item.name}}</TableTd>
            <TableTd>{{item.quantity}}</TableTd>
          </:body>
        </Table>
      </:default>
    </Box>
  </template>
}
